import React from 'react';
import VehicleListingsPage from '../Components/vehicle-listings-page';

const Vlp = ({ type }) => {
  return (
    <VehicleListingsPage type={type} />
  );
};

export default Vlp;

